<template>
  <div>
    <div class="question__item">
      <BaseContent :info="params"></BaseContent>
      <el-form class="question__form">
        <el-form-item class="question__form--item">
          <el-checkbox-group v-model="form.checkboxArr">
            <div>
              <div class="group__item" v-for="item in info.option" :key="item.o_id">
                <el-checkbox
                  :label="item.o_id"
                  :disabled="item.o_is_disabled"
                  @change="changeSelect($event,item)"
                >
                  <div>
                    <div class="ui_label">{{item.o_name}}</div>
                    <div class="ui_text" v-show="item.o_has_input === 1">
                      <el-input
                        @focus="focusSelect(item.o_id)"
                        v-model="form.inputsValue[item.o_id]"
                        @blur="changeInput(item.o_id)"
                        :disabled="item.o_is_disabled"
                      ></el-input>
                    </div>
                  </div>
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <ErrMessage
         v-show="errShow"
         :visible="errShow"
         :title="errTitle"
        >
        </ErrMessage>
      </el-form>
    </div>
    <check-item
      :check="params.check"
      :form="form"
      v-on="$listeners"
      v-bind="$attrs"
      @upCheck="upCheck"></check-item>
  </div>
</template>
<script>
import ErrMessage from '../../components/errorMessage'
import BaseContent from './baseContent'
import { BASE_TYPE_CHECK_DATA_FUN } from '../constant/index'
import { mixin } from '../constant/mixin'
import * as CHECK_DATA_FUN from '../constant/method'
import CheckItem from './checkItem'
export default {
  name: 'multiSelect',
  props: {
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    ErrMessage,
    BaseContent,
    CheckItem
  },
  mixins: [mixin],
  data () {
    return {
      info: {},
      form: {
        checkboxArr: [],
        inputsValue: {},
        q_category: '',
        question_id: '',
        q_answer_info: '',
        q_option_id: '',
        q_remark: '',
        q_is_required: 0,
        o_is_required: 0,
        o_has_input: 0,
        o_is_conflict: 0,
        option: [],
        data_datetime: '',
        is_kaocha: '',
        remark: '',
        q_group_id: '',
        q_number: ''
      },
      saveInputValue: {},
      conflictArr: [],
      conflictArr_zero: [],
      requiredArr: [],
      errShow: false,
      errTitle: '',
      inputIsChange: false // 是否则改变input的值只做校验不请求逻辑接口
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('pick', val)
      },
      deep: true
    }
  },
  computed: {
    checkFun () {
      return CHECK_DATA_FUN[BASE_TYPE_CHECK_DATA_FUN[this.form.q_category]]
    }
  },
  methods: {
    checkData (isSubmit) {
      let checkResult = this.checkFun(this.form, this.params)
      if (checkResult.noData) {
        this.errShow = true
        this.errTitle = checkResult.errTitle
      } else {
        this.errShow = false
        if (!this.inputIsChange) {
          !isSubmit && this.logicalHandler()
        }
      }
    },
    focusSelect (id) {
      this.inputIsChange = true
      let isConflict = this.conflictArr.includes(id)
      if (isConflict) { //  互斥的
        this.form.checkboxArr = []
        Object.keys(this.form.inputsValue).forEach(item => {
          if (item !== String(id)) {
            this.form.inputsValue[item] = ''
          }
        })
        this.form.checkboxArr.push(id)
      } else {
        let includeId = this.form.checkboxArr.includes(id)
        if (!includeId) {
          this.form.checkboxArr.push(id)
        }
      }
      let saveValue = this.saveInputValue[id] || ''
      if (saveValue) {
        this.form.inputsValue[id] = saveValue
      }
      this.checkData()
    },
    changeSelect (value, option) {
      let arr = this.conflictArr.find(c_item => {
        return this.form.checkboxArr.includes(c_item)
      })
      if (arr && value) { // 选中并且互斥
        this.form.checkboxArr = []
        this.form.checkboxArr.push(option.o_id)
        Object.keys(this.form.inputsValue).forEach(id => {
          if (id !== String(option.o_id)) {
            this.form.inputsValue[id] = ''
          }
        })
      }
      let inputValue = this.form.inputsValue[option.o_id] || ''
      let saveValue = this.saveInputValue[option.o_id] || ''
      if (!value && inputValue) { // 多选框取消选中且输入框存在有值
        this.form.inputsValue[option.o_id] = ''
      } else if (value && saveValue) {
        this.form.inputsValue[option.o_id] = saveValue
      }

      let new_checkboxArr = []
      this.info.option.map((Oitem, index) => {
        this.form.checkboxArr.map(item => {
          if (item === Oitem.o_id && Oitem.o_is_disabled === false) {
            new_checkboxArr.push(item)
          }
        })
      })
      this.form.checkboxArr = new_checkboxArr
      this.checkData()
    },
    changeInput (id) {
      this.inputIsChange = false
      this.saveInputValue[id] = this.form.inputsValue[id]
      let new_checkboxArr = []
      this.info.option.map((Oitem, index) => {
        this.form.checkboxArr.map(item => {
          if (item === Oitem.o_id && Oitem.o_is_disabled === false) {
            new_checkboxArr.push(item)
          }
        })
      })
      this.form.checkboxArr = new_checkboxArr
      this.checkData()
    },
    drawing (option) {
      let that = this
      if (option.o_is_conflict === 1) {
        this.conflictArr_zero.map((c_item, index) => {
          that.info.option.map((o_item) => {
            if (c_item === o_item.o_id) {
              o_item.o_is_disabled = true
            }
          })
        })

        this.conflictArr.map((c_item, index) => {
          that.info.option.map((o_item) => {
            if (c_item !== option.o_id && c_item === o_item.o_id) {
              o_item.o_is_disabled = true
            }
          })
        })
      } else if (option.o_is_conflict === 0) {
        this.conflictArr.map((c_item, index) => {
          that.info.option.map((o_item) => {
            if (c_item === o_item.o_id) {
              o_item.o_is_disabled = true
            }
          })
        })
      }

      let new_checkboxArr = []
      this.info.option.map((Oitem, index) => {
        this.form.checkboxArr.map(item => {
          if (item === Oitem.o_id && Oitem.o_is_disabled === false) {
            new_checkboxArr.push(item)
          }
        })
      })
      this.form.checkboxArr = new_checkboxArr
    },
    upCheck (val) {
      this.form = Object.assign(this.form, val)
    }
  },
  mounted () {
    this.info = { ...this.info, ...this.params }
    Object.keys(this.form).forEach(item => {
      if (item !== 'checkboxArr' && item !== 'inputsValue') {
        this.form[item] = this.params[item] || ''
      }
      if (item === 'data_datetime') {
        this.form[item] = this.params.check[0] && this.params.check[0].data_datetime
      }
      if (item === 'remark') {
        this.form[item] = this.params.check[0] && this.params.check[0].remark
      }
    })
    if (!this.params.option) return
    this.params.option.forEach(p_value => {
      if (p_value.o_is_conflict === 1) {
        this.conflictArr.push(p_value.o_id) // 互斥为1的数组
      }
      if (p_value.o_is_conflict === 0) {
        this.conflictArr_zero.push(p_value.o_id) // 互斥为0的数组
      }
      if ((p_value.o_default_selected === 1 || p_value.o_is_required === '1') && p_value.o_is_disabled === false) {
        this.form.checkboxArr.push(p_value.o_id)
      }
      if (p_value.q_remark && p_value.o_has_input === 1) {
        this.$set(this.form.inputsValue, p_value.o_id, p_value.q_remark)
        this.$set(this.saveInputValue, p_value.o_id, p_value.q_remark)
      }
      if (p_value.o_is_required === '1') { // 必填写
        this.requiredArr.push(p_value)
      }
    })
    if (this.params.relation === 'and') {
      this.requiredArr.map(item => {
        this.drawing(item)
      })
    }
  }
}
</script>
<style lang="scss">
.el-checkbox__label{
  display: inline-flex;
}
.ui_label{
  white-space: normal;
  display: inline;
}
</style>
